"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cella-dati": {
    "3e408e69": [{
      "hkey": "a46dafc8",
      "slug": "cella-dati",
      "name": "Cella Dati",
      "primary": true,
      "skipSearch": false
    }],
    "pugnolo": [{
      "hkey": "a46dafc8",
      "slug": "cella-dati",
      "name": "Cella Dati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f061610": [{
      "hkey": "a46dafc8",
      "slug": "cella-dati",
      "name": "Cella Dati",
      "primary": true,
      "skipSearch": false
    }],
    "reboana": [{
      "hkey": "a46dafc8",
      "slug": "cella-dati",
      "name": "Cella Dati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9b9d9dbb": [{
      "hkey": "a46dafc8",
      "slug": "cella-dati",
      "name": "Cella Dati",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo-mondinari": [{
      "hkey": "a46dafc8",
      "slug": "cella-dati",
      "name": "Cella Dati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;